import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ModalContextProvider from "./utils/ModalContextProvider";
import {MoralisProvider} from "react-moralis";
import App from "./app/App";
import NFTContextProvider from "./utils/NFTContextProvider";

const appId = process.env.REACT_APP_APPLICATION_ID;
const serverUrl = process.env.REACT_APP_SERVER_URL;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <MoralisProvider appId={appId} serverUrl={serverUrl}>
    <NFTContextProvider>
        <ModalContextProvider>
      <BrowserRouter>
          <App />
      </BrowserRouter>
        </ModalContextProvider>
    </NFTContextProvider>
  </MoralisProvider>
);
